export enum ValidatorRules {
  REQUIRED = 'required',
  NUMBER = 'number',
  EMAIL = 'email',
  ALPHABET = 'alphabet',
  TELEPHONE = 'telephone',
}
